import type { MessageKey } from 'types/LocaleMessageKey';

import {
  ONE_MONTH_MEMBERSHIP_SELECTED_SUMMARY_KEY,
  ONE_YEAR_MEMBERSHIP_SELECTED_SUMMARY_KEY,
} from '@/app/[locale]/product/_components/HardwarePDP/_hooks/useBuildRingOrder/buildOrderReducer';
import type { RefreshCart_cart_refreshCart_cart_lineItems } from '@/queries/types/RefreshCart';

import { MEMBERSHIP_1MONTH_SKU, MEMBERSHIP_1YEAR_SKU } from '../_consts';
import MembershipSelection from '../_steps/enums/MembershipSelection';

export interface GetMembershipSelection {
  value: MembershipSelection;
  sku: string;
  summaryKey: MessageKey;
}

const getMembershipSelection = (
  lineItem: RefreshCart_cart_refreshCart_cart_lineItems | null | undefined,
): GetMembershipSelection => {
  const sku = lineItem?.skuCode ?? '';

  if (sku === MEMBERSHIP_1YEAR_SKU) {
    return {
      value: MembershipSelection.OneYear,
      sku,
      summaryKey: ONE_YEAR_MEMBERSHIP_SELECTED_SUMMARY_KEY,
    };
  } else {
    return {
      value: MembershipSelection.OneMonth,
      sku: MEMBERSHIP_1MONTH_SKU,
      summaryKey: ONE_MONTH_MEMBERSHIP_SELECTED_SUMMARY_KEY,
    };
  }
};

export default getMembershipSelection;
